import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Translate, withLocalize } from 'react-localize-redux';

class SimpleSearchStats extends React.Component {
    static propTypes = {
        page: PropTypes.number,
        totalPages: PropTypes.number,
        coundCount: PropTypes.number,
        totalCount: PropTypes.number,
        classNames: PropTypes.object,
        dbInfo: PropTypes.bool
    };

    static defaultProps = {
        page: 0,
        totalPages: 0,
        foundCount: 0,
        totalCount: 0,
        classNames: {},
        dbInfo: false
    };

    render() {
        const { page, totalPages, foundCount, totalCount, classNames, dbInfo } = this.props;

        return (
            <div className={classnames("result-counts", classNames)} style={{ flex: "1 0" }}>
                <span>
                    <Translate id="SearchResult.ResultsCount" />:&nbsp;
                    {dbInfo ? 
                        <Translate id="Search.Liens.ResultSummary" data={{
                            found: foundCount.toLocaleString(this.props.activeLanguage.code),
                            total: totalCount.toLocaleString(this.props.activeLanguage.code)
                        }} options={{ renderInnerHtml: true }} /> 
                        : 
                        <b>{foundCount}</b>                    
                    } |&nbsp;
                    <Translate id="Property.Page" />:&nbsp;
                    <b>{page} / {totalPages}</b>
                </span>
            </div>
        );
    }
}

export default withLocalize(SimpleSearchStats);